'use strict';

import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import style from './index.less.module';

export default class Notice extends Component {
    constructor(props) {
        super(props);
        this.setting = {
            LSKEY: 'dp_speaker',
            defaultLS: true, // 默认存储LS
            frequency: 1 // 关闭后重新出现的频率，单位为天
        }
        Object.assign(this.setting, this.props.opt || {})
        this.state = {
            isShowNotice: this.validate()
        }
        this.closeHandle = this.closeHandle.bind(this);
    }

    componentDidMount() {
        let { succHandle } = this.props;
        if (this.state.isShowNotice && typeof succHandle == 'function') {
            succHandle();
        }
    }
    
    render({ content, clickHandle, positionStyle } = this.props) {
        return (
            this.state.isShowNotice ? (
                <div className={style["notice_wrap"]} style={positionStyle}>
                    <i className={style["icon_notice"]}></i>
                    <p className={style["notice_content"]} onClick={clickHandle}>{content}</p>
                    <i className={style["icon_close"]} onClick={this.closeHandle}></i>
                </div>
            ) : <div></div>
        )
    }

    validate() {
        // 校验LS的时间戳是否已失效
        try {
            if (!this.setting.defaultLS || !supportLocalStorage()) {
                // 不支持LocalStorage，默认展示
                return true
            }
            const { LSKEY, frequency } = this.setting;
            const storedNotice = JSON.parse(localStorage.getItem(LSKEY));
            if (!storedNotice || Date.now() - storedNotice.timestamp > frequency * 24 * 60 * 60 * 1000) {
                return true // 未存储该KEY值（未进行关闭操作）或已过`有效期`
            }
            return false;
        } catch(e) {
            return false
        }
    }

    closeHandle(e) {
        e.preventDefault();
        let { closeHandle } = this.props;
        if (this.setting.defaultLS && supportLocalStorage()) {
            // 业务支持、技术支持LocalStorage
            const { LSKEY } = this.setting;
            // 进入`静默期`（倒计时）
            localStorage.setItem(LSKEY, JSON.stringify({
                timestamp: Date.now(),
                source: 'activity-web'
            }));
        }
        this.setState({
            isShowNotice: false
        })
        typeof closeHandle == 'function' && closeHandle();
    }
}

function noop() {}

function supportLocalStorage() {
    let support = false;
    let testKey = 'local_test';
    try {
        support = !!window.localStorage && window.localStorage != null;
        localStorage.setItem(testKey, 1);
        localStorage.removeItem(testKey);
    } catch(e) {
        return false;
    }
    return support;
};




// WEBPACK FOOTER //
// ./src/common/component/notice/index.jsx